import { Action } from '@/_core/fluxstore/types';
import { ProductsState } from '../types';
import { useProductsStore } from '../useModule';
import { useLocalStorage } from 'vue-composable';
import { ChangeCurrentProduct } from './changeCurrentProduct';

const { registerReducer, dispatch } = useProductsStore();

export class InitProducts extends Action<ProductsState> {
    public static ACTION_TYPE = 'InitProducts';

    public constructor() {
        super(InitProducts.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: ProductsState, action: InitProducts): void => {
    if (initAppData.isInWsContext) {
        state.products = [...initAppData.currentWs.products];

        const { storage: lastProductSlug } = useLocalStorage(`_storiesonboard_lastProductSlug-${initAppData.currentWs.workspaceId}`, null);
        dispatch(new ChangeCurrentProduct(lastProductSlug.value));
    } else {
        state.products = [];
    }

    state.isInitialized = true;
};

//@ts-ignore
registerReducer(InitProducts.ACTION_TYPE, reducer);
